import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { DisclaimerContent } from "../components/disclaimer-content"

const DisclaimerPage = () => (
  <Layout>
    <SEO title="Disclaimer" />
    <DisclaimerContent />
  </Layout>
)

export default DisclaimerPage
